module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"Mi búsqueda":"Mi búsqueda"},"en":{"Mi búsqueda":"My search"},"ca":{"Mi búsqueda":"La meva cerca"}}')
  delete Component.options._Ctor
}
